export default __webpack_public_path__ + "static/media/fastSkip.d183d097.png";